import {Component, EventEmitter, Input, OnInit, Output, TemplateRef} from '@angular/core';
import {KamonaDialogType, KamonaDialogDesign} from '../../../../kamona/model/kamonal-model';

@Component({
	selector: 'app-moniepoint-dialog',
	templateUrl: './moniepoint-dialog.component.html',
	styleUrls: ['./moniepoint-dialog.component.scss']
})
export class MoniepointDialogComponent implements OnInit {
	@Input() title: string;
	@Input() message: string;
	@Input() className: string;
	@Input() thumbnailTpl?: TemplateRef<unknown>;
	@Input() dialogType?: 'default' | 'info' | 'confirm' | 'sucess' | 'error' | 'warning' | 'custom' | 'delete' | string;
	@Input() icon: TemplateRef<any>;
	@Input() content: Component;
	@Input() submitting: boolean;
	@Output() retry = new EventEmitter();
	@Output() cancel = new EventEmitter();
	@Output() confirm = new EventEmitter();
	@Output() completeConfirmation = new EventEmitter();
	@Output() closeModal = new EventEmitter();
	@Input() dialogDesign: KamonaDialogDesign = KamonaDialogDesign.OLD;
	@Input() kamonaDialogType: KamonaDialogType = KamonaDialogType.BASIC;
	KamonaModalDesign = KamonaDialogDesign;
	KamonaDialogType = KamonaDialogType;
	checked: boolean;

	constructor() {
	}

	ngOnInit() {
		if (!this.dialogType && !this.icon) {
			this.dialogType = 'info';
		}
	}

	confirmAlert() {
		this.setConfirm(true);
	}

	setConfirm(value: boolean) {
		this.confirm.emit(value);
	}

	confirmation() {
		this.setCompleteConfirmation(true);
	}

	setCompleteConfirmation(value: boolean) {
		this.completeConfirmation.emit(value);
	}

	cancelAlert() {
		this.setCancelAlert(true);
	}

	setCancelAlert(value: boolean) {
		this.cancel.emit(value);
	}

	cancelModalAlert() {
		this.setCancelModalAlert(true);
	}

	setCancelModalAlert(value: boolean) {
		this.closeModal.emit(value);
	}

	retryAlert() {
		this.setRetryAlert(true);
	}

	setRetryAlert(value: boolean) {
		this.retry.emit(value);
	}
}
